import React from 'react';
import ReactTooltip from 'react-tooltip';
import Kbd from 'design-system/Kbd';
/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TranscriptionAudioAttachmentTooltip() {
  const classes = useStyles();
  return (
    <>
      <div className={classes.infoIcon} data-tip data-for={'keyboard-shortcut-menu'}>
        <FontAwesomeIcon icon="info-circle" color="gray" />
      </div>
      <ReactTooltip
        id={'keyboard-shortcut-menu'}
        place="top"
        type="light"
        multiline={true}
        effect="float"
      >
        <div className={classes.documentationText}>
          <h3>KEYBOARD SHORTCUTS</h3>
          <div className={classes.shortcut}>
            <div>Play/pause</div>
            <Kbd>Ctrl</Kbd>
          </div>
          <div className={classes.shortcut}>
            <div>Rewind 5 seconds</div>
            <Kbd>Left</Kbd>
          </div>
          <div className={classes.shortcut}>
            <div>Forward 5 seconds</div>
            <Kbd>Right</Kbd>
          </div>
          <div className={classes.shortcut}>
            <div>Slow down</div>
            <div className={classes.comboKeys}>
              <Kbd>Shift</Kbd>
              <div>+</div>
              <Kbd>Left</Kbd>
            </div>
          </div>
          <div className={classes.shortcut}>
            <div>Speed up</div>
            <div className={classes.comboKeys}>
              <Kbd>Shift</Kbd>
              <div>+</div>
              <Kbd>Right</Kbd>
            </div>
          </div>
          <div className={classes.shortcut}>
            <div>Volume down</div>
            <Kbd>Down</Kbd>
          </div>
          <div className={classes.shortcut}>
            <div>Volume up</div>
            <Kbd>Up</Kbd>
          </div>
          <div className={classes.shortcut}>
            <div>Copy current position</div>
            <Kbd>C</Kbd>
          </div>
        </div>
      </ReactTooltip>
    </>
  );
}

const useStyles = makeStyles({
  infoIcon: {
    paddingLeft: '8px',
    textAlign: 'left',
    lineHeight: '32px',
    cursor: 'pointer',
  },

  documentationText: {
    whiteSpace: 'pre-line',
    color: '#5e5e5e',
    backgroundColor: 'white',
    fontWeight: 200,
    borderRadius: 4,
    width: 200,
  },
  shortcut: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 13,
    margin: '12px 0',
  },
  comboKeys: {
    flexDirection: 'row',
    display: 'flex',
  },
  shortcutKeys: {
    alignItems: 'center',
  },
  shortcutKey: {
    padding: '2px 6px',
    border: 'solid 1px #ccc',
    borderRadius: 4,
    fontSize: 12,
  },
  combo: {
    padding: '0 4px',
  },
});
